import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "navigate_before", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "navigate_next", -1)

import { computed, ref, watch } from "vue";

import VuePdfEmbed from "vue-pdf-embed";
import { downloadFileNode } from "../../api";
import { arraybufferToBase64 } from "../../utils";
import { onMounted } from "vue";
import Btn from "../ui/Btn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntegratedFileViewer',
  props: {
	src: {
		type: String,
		required: true,
	},
	page: {
		type: Number,
		default: 1,
	},
},
  setup(__props) {

const props = __props;



const downloading = ref(false);
const source = ref("");
const arrayBufferSource = ref<ArrayBuffer | null>(null);

// const page = ref<number>(1);

const base64Source = computed(() => `data:application/pdf;base64,${source.value}`);

const downloadNodeFile = async () => {
	console.log("Downloading file from node...");
	downloading.value = true;
	const fileArrayBuffer = await downloadFileNode(
		props.src,
		e => null,
		// self.onDownloadProgress?.(e),
	);
	source.value = arraybufferToBase64(fileArrayBuffer);
	arrayBufferSource.value = fileArrayBuffer;
	downloading.value = false;

	// if (props.initialPage) {
	// 	setTimeout(() => (page.value = props.initialPage), 100);
	// }
};

watch(
	() => props.src,
	(newSrc, oldSrc) => {
		if (newSrc !== oldSrc) {
			downloadNodeFile();
		}
	},
	{ immediate: true },
);

// onMounted(() => {
// 	downloadNodeFile();
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(VuePdfEmbed), {
      id: 'id',
      width: 700,
      ref: "pdfRef",
      source: _unref(base64Source),
      page: __props.page,
      "disable-annotation-layer": false
    }, null, 8, ["source", "page"]),
    (!downloading.value && _unref(base64Source))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Btn, {
            class: "mt-2",
            loading: downloading.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pageChanged', __props.page - 1))),
            variant: 'icon',
            outline: true
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["loading"]),
          _createTextVNode(" " + _toDisplayString(__props.page) + " ", 1),
          _createVNode(Btn, {
            class: "mt-2",
            loading: downloading.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('pageChanged', __props.page + 1))),
            variant: 'icon',
            outline: true
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})